export const ApiBaseUrl = `${process.env.REACT_APP_API_END_POINT}`;

//controler
export const Customer = "/api/Customer";
export const Branch = "/api/Branch";
export const Supplier = "/api/Supplier";
// export const ApiBaseUrl = (window as any).BASE_URL;
export const KycBaseUrl = "/api/Account";
export const BasicInformationBaseUrl = "/api/BasicInformation";
export const LoanBaseUrl = "/api/Loan";
export const CartableBaseUrl = "/api/Cartable";
export const SupplierBaseUrl = "/api/Supplier";
export const SupplierUserBaseUrl = "/api/SupplierUser";
//new newName api
export const Wizard = "/api/Wizard"; //SupplierSettlementBaseUrl
export const CustomerInformationBaseUrl = "/api/CustomerInformation"; //SupplierSettlementCustomerInformationBaseUrl
export const IncomeBaseUrl = "/api/Income"; //SupplierSettlementIncomeBaseUrl
export const ChequeBaseUrl = "/api/Cheque"; //SupplierSettlementChequeBaseUrl
export const FactorBaseUrl = "/api/Factor"; //SupplierSettlementFactorBaseUrl
export const ContractBaseUrl = "/api/Contract"; //SupplierSettlementContractBaseUrl
export const SupplierNoticeBaseUrl = "/api/SupplierNotice";
export const VehicleBaseUrl = "/api/Vehicle";
export const VehicleExpertBaseUrl = "/api/VehicleExpert";
export const SellerBaseUrl = "/api/Seller";
export const GuarantorBaseUrl = "/api/Guarantor";
export const GuarantorChequeBaseUrl = "/api/GuarantorCheque";
export const SupplierPaymentUrl = "/api/SupplierPayment";
export const StoreUrl = "/api/Store";
export const LoanTemplateWhiteList = "/api/LoanTemplateWhiteList";
/////////////////////suppSamiin
export const SaleUrl = "/api/Sale";
export const DropdownUrl = "/api/Dropdown";
